var map = {
	"./icons/academic.svg": 8474,
	"./icons/add-form.svg": 25679,
	"./icons/add.svg": 71480,
	"./icons/alert.svg": 37727,
	"./icons/app.svg": 68160,
	"./icons/arrow-down.svg": 31759,
	"./icons/arrow-left.svg": 65648,
	"./icons/arrow-right.svg": 76415,
	"./icons/arrow-up.svg": 46688,
	"./icons/arrows-down.svg": 48278,
	"./icons/arrows-left.svg": 88189,
	"./icons/arrows-right.svg": 22368,
	"./icons/arrows-up.svg": 79533,
	"./icons/audio.svg": 43263,
	"./icons/background.svg": 72539,
	"./icons/bag.svg": 83351,
	"./icons/bars-large.svg": 90419,
	"./icons/bars.svg": 12117,
	"./icons/book.svg": 59316,
	"./icons/books.svg": 39615,
	"./icons/calendar.svg": 85033,
	"./icons/card-2.svg": 16712,
	"./icons/card.svg": 94817,
	"./icons/cardio.svg": 70753,
	"./icons/categories.svg": 70731,
	"./icons/category.svg": 39767,
	"./icons/certificate.svg": 62156,
	"./icons/change.svg": 46875,
	"./icons/chat.svg": 98701,
	"./icons/checklist.svg": 47593,
	"./icons/clock.svg": 92075,
	"./icons/close.svg": 35837,
	"./icons/cockpit.svg": 67010,
	"./icons/color.svg": 2788,
	"./icons/company.svg": 92024,
	"./icons/condition.svg": 26286,
	"./icons/confirmed.svg": 2702,
	"./icons/copy.svg": 28552,
	"./icons/d-pad.svg": 38725,
	"./icons/document-a.svg": 41734,
	"./icons/document-medicine.svg": 98005,
	"./icons/document-search.svg": 53229,
	"./icons/document.svg": 152,
	"./icons/download.svg": 91303,
	"./icons/drops.svg": 41307,
	"./icons/edit-form.svg": 31690,
	"./icons/edit.svg": 975,
	"./icons/email.svg": 11089,
	"./icons/equipment.svg": 95465,
	"./icons/evaluate.svg": 80338,
	"./icons/exit.svg": 43579,
	"./icons/eye-closed.svg": 44531,
	"./icons/eye.svg": 34426,
	"./icons/field.svg": 5865,
	"./icons/filter.svg": 87985,
	"./icons/finances.svg": 91938,
	"./icons/fire.svg": 2047,
	"./icons/form.svg": 30217,
	"./icons/game.svg": 45417,
	"./icons/gamepad.svg": 48364,
	"./icons/gift.svg": 66081,
	"./icons/grid.svg": 33591,
	"./icons/group.svg": 7544,
	"./icons/hearth.svg": 25447,
	"./icons/home-filled.svg": 32779,
	"./icons/home-line.svg": 65021,
	"./icons/info.svg": 36947,
	"./icons/instagram.svg": 85373,
	"./icons/laboratory.svg": 7564,
	"./icons/layer.svg": 31158,
	"./icons/layout.svg": 87097,
	"./icons/loading.svg": 67649,
	"./icons/lock-open.svg": 41823,
	"./icons/lock.svg": 45482,
	"./icons/lung.svg": 24148,
	"./icons/man.svg": 31009,
	"./icons/map-pin.svg": 35789,
	"./icons/medicines.svg": 53378,
	"./icons/method.svg": 7876,
	"./icons/newsletter.svg": 50626,
	"./icons/no-image.svg": 56754,
	"./icons/options.svg": 94291,
	"./icons/order-await.svg": 94092,
	"./icons/order-checked.svg": 81369,
	"./icons/page.svg": 18174,
	"./icons/pause.svg": 51947,
	"./icons/person.svg": 14388,
	"./icons/phone.svg": 16345,
	"./icons/pin.svg": 92528,
	"./icons/plans.svg": 91029,
	"./icons/platform.svg": 94242,
	"./icons/play.svg": 33138,
	"./icons/podcast.svg": 7754,
	"./icons/print.svg": 64684,
	"./icons/refresh.svg": 32304,
	"./icons/reports.svg": 13748,
	"./icons/rudder.svg": 35017,
	"./icons/samples.svg": 70952,
	"./icons/save.svg": 44660,
	"./icons/search.svg": 64343,
	"./icons/send.svg": 46385,
	"./icons/services.svg": 31315,
	"./icons/settings.svg": 20716,
	"./icons/shapes.svg": 41969,
	"./icons/shield.svg": 66164,
	"./icons/signal-off.svg": 38543,
	"./icons/signal.svg": 11479,
	"./icons/signature.svg": 74531,
	"./icons/skill.svg": 66070,
	"./icons/sleep.svg": 95812,
	"./icons/square.svg": 77102,
	"./icons/star.svg": 40815,
	"./icons/steps.svg": 45064,
	"./icons/summary.svg": 79629,
	"./icons/target.svg": 91220,
	"./icons/technical.svg": 62380,
	"./icons/temperature.svg": 62491,
	"./icons/time-b.svg": 72005,
	"./icons/time.svg": 97592,
	"./icons/trash.svg": 36891,
	"./icons/upload.svg": 50600,
	"./icons/web.svg": 69215,
	"./icons/whatsapp.svg": 34609,
	"./icons/woman.svg": 15523,
	"./icons/yacht.svg": 4588,
	"./icons/youtube-icon.svg": 95904,
	"./icons/youtube.svg": 72054,
	"./icons/zoom.svg": 42226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72193;